import React, { useState, useEffect } from 'react';
// import socketIOClient from 'socket.io-client';
import './form.css';
// Assets
import logo from './assets/usku_logo.png';
import loading_gif from './assets/loading.gif';

const SignUpForm = () => {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [emailAddress, setEmailAddress] = useState("");
    const [password, setPassword] = useState("");
    const [homeAddress, setHomeAddress] = useState("");
    const [postcode, setPostcode] = useState("");
    const [abn, setAbn] = useState("");
    const [bankName, setBankName] = useState("");
    const [bankBsb, setBankBsb] = useState("");
    const [bankAccountNumber, setBankAccountNumber] = useState("");
    const [deliveryVehicle, setDeliveryVehicle] = useState("");

    const [formPage, setFormPage] = useState(true);
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const sendOrder = () => {
        setSubmitted(true);
        if (!firstName || !lastName || !phoneNumber || !emailAddress || !homeAddress || !postcode ||
            !abn || !bankName || !bankBsb || !bankAccountNumber || !deliveryVehicle)
        {
            console.log("missing field");
            return;
        }
        else {
            setLoading(true);
            setTimeout(() => {
                setLoading(false);
                setFormPage(false);

            }, 3000)
            const message = formatMessage();
            console.log(message);

            fetch('https://usku-delivery-server.herokuapp.com/signup-deliverers', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    firstName,
                    lastName,
                    phoneNumber,
                    emailAddress,
                    password,
                    homeAddress,
                    postcode,
                    abn,
                    bankName,
                    bankBsb,
                    bankAccountNumber,
                    deliveryVehicle,
                })
            })
            .then((response) => response.json())
            .then((data) => {
              console.log('Success:', data);
            })
            .catch(err => console.log("Error: ", err))
        }
    }

    const formatMessage = () => {
        let message = `
            *First Name:*
            ${firstName}\n
            *Last Name:*
            ${lastName}\n
            *Phone Number:*
            ${phoneNumber}\n
            *Email Address:*
            ${emailAddress}\n
            *Password:*
            $${password}\n
            *Home Address*
            ${homeAddress}\n
            *Postcode:*
            ${postcode}\n
            *ABN:*
            ${abn}\n
            *Bank Name:*
            ${bankName}\n
            *BSB Number:*
            ${bankBsb}\n
            *Bank Account Number:*
            ${bankAccountNumber}\n
            *Delivery Vehicle:*
            ${deliveryVehicle}\n
        `

        return message.replace(/ /g,'');
        ;
    }

    if (formPage) {
        return (
            <div className="form">
            <div className="form-container">
                <img className="usku-logo" src={logo} alt="Usku" />
                <h1>Sign Up as Deliverers</h1>
                <p>You will hear from us shortly after submitting the form</p>
                <h3>Personal Information</h3>
                <div className="input-container">
                    <label className={(!firstName && submitted) ? 'red' : ''}>First Name</label>
                    <input onChange={(e) => setFirstName(e.target.value)} type="text" value={firstName} placeholder="First Name" />
                </div>
                <div className="input-container">
                    <label className={(!lastName && submitted) ? 'red' : ''}>Last Name</label>
                    <input onChange={(e) => setLastName(e.target.value)} type="text" value={lastName} placeholder="Last Name" />
                </div>
                <div className="input-container">
                    <label className={(!phoneNumber && submitted) ? 'red' : ''}>Phone Number</label>
                    <input onChange={(e) => setPhoneNumber(e.target.value)} type="text" value={phoneNumber} placeholder="+610404040404" />
                </div>
                <div className="input-container">
                    <label className={(!emailAddress && submitted) ? 'red' : ''}>Email Address</label>
                    <input onChange={(e) => setEmailAddress(e.target.value)} type="text" value={emailAddress} placeholder="example@example.com" />
                </div>
                <div className="input-container">
                    <label className={(!password && submitted) ? 'red' : ''}>Create Password</label>
                    <input onChange={(e) => setPassword(e.target.value)} type="text" value={password} />
                </div>
                <br/>
                <h3>Address Information</h3>
                <div className="input-container">
                    <label className={(!homeAddress && submitted) ? 'red' : ''}>Home Address</label>
                    <input onChange={(e) => setHomeAddress(e.target.value)} type="text" value={homeAddress} placeholder="24 Bell St, Melbourne" />
                </div>
                <div className="input-container">
                    <label className={(!postcode && submitted) ? 'red' : ''}>Postcode</label>
                    <input onChange={(e) => setPostcode(e.target.value)} type="text" value={postcode} placeholder="3000" />
                </div>
                <div className="input-container">
                    <label className={(!deliveryVehicle && submitted) ? 'red' : ''}>Delivery Vehicle</label>
                    <input onChange={(e) => setDeliveryVehicle(e.target.value)} type="text" value={deliveryVehicle} placeholder="Car" />
                </div>
                <br/>
                <h3>Banking Information</h3>
                <div className="input-container">
                    <label className={(!abn && submitted) ? 'red' : ''}>ABN</label>
                    <input onChange={(e) => setAbn(e.target.value)} type="text" value={abn} />
                </div>
                <div className="input-container">
                    <label className={(!bankName && submitted) ? 'red' : ''}>Bank Name</label>
                    <input onChange={(e) => setBankName(e.target.value)} type="text" value={bankName} placeholder="Commonwealth Bank" />
                </div>
                <div className="input-container">
                    <label className={(!bankBsb && submitted) ? 'red' : ''}>BSB Number</label>
                    <input onChange={(e) => setBankBsb(e.target.value)} type="text" value={bankBsb} />
                </div>
                <div className="input-container">
                    <label className={(!bankAccountNumber && submitted) ? 'red' : ''}>Bank Account Number</label>
                    <input onChange={(e) => setBankAccountNumber(e.target.value)} type="text" value={bankAccountNumber} />
                </div>

                <p>By submitting the form, you have read and agree to our <a href="https://uskutech.com/legal/" target="_blank">terms and conditions</a> of our services</p>

                <button onClick={() => sendOrder()}>Sign Up</button>
                <div className="footer">
                    &copy; Uskutechnologies 2020
                </div>
                <div className={loading ? 'loading-overlay show' : 'loading-overlay'}>
                    <img className="loading" src={loading_gif} alt="Usku" />
                </div>
            </div>
        </div>
        )
    } else {
        return (
            <div className="form">
                <div className="form-container">
                    <img className="usku-logo" src={logo} alt="Usku" />
                    <p>Your request has been submitted</p>
                    <p>Thank you for your time. We will be reaching you out soon.</p>
                    <p>If you have any other enquiries, feel free to visit our <a href="https://uskutech.com/faqs/">FAQs</a> page or leave a <a href="https://uskutech.com/home/contact-us/">message</a> to us</p>
                    <div className="footer">
                        &copy; Uskutechnologies 2020
                    </div>
                </div>
            </div>
        )
    }
}

export default SignUpForm;